// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"m1-z","dimensionLabel":"n1-z","styleChooserControlWrapper":"o1-z","styleChooserControl":"p1-z","disabled":"q1-z","giftCard":"r1-z","styleChooserText":"s1-z"};